import { IconClock, IconMapPin } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import axios from "axios";
import UrlServices from "../../../services/Url";
import "containers/BookingList/BookingDetails/index.css";
import { useContext, useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import toast, { Toaster } from "react-hot-toast";
import { formatTo12Hour } from "utils";
import { BeatLoader } from "react-spinners";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { format } from "date-fns";
const { formatInTimeZone } = require("date-fns-tz");

const BookingDetails = (props) => {
  const { bookingDetail, getStoreTime } = props;
  // const [value, setValue] = useState(new Date());
  const [value, setValue] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Local midnight
  });
  
  const [times, setTimes] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [filteredTime, setFilteredTime] = useState([]);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const [width, setWidth] = useState(300);
  const timesSectionRef = useRef(null);
  const isInitialRender = useRef(true);
  const {
    appointmentDetail,
    setAppointmentDetail,
    fetchTimeLoading,
    setFetchTimeLoading,
    buttonClicked,
    encryptionKey,
    isWebView,
    userSettings,
    countryDetails,
  } = useContext(AppContext);

  const key = "AIzaSyBlqrSdiC-YtE8DGNRJXRGXyoFQiHGsER4";

  // Function to open Google Maps in a new tab on mobile
  const handleViewMap = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      bookingDetail.address
    )}`;
    window.open(mapsUrl, "_blank"); // Open Google Maps in a new tab
  };

  // Function to scroll to the times section and adjust vertical scroll if necessary
  const scrollToTimesSection = (skipScrollAdjustment = false) => {

    const fullUrl = window.location.href;
    const containsDevOrMaster = fullUrl.includes("dev.") || fullUrl.includes("master.") || fullUrl.includes("localhost:3000");

    if (timesSectionRef.current) {
      // Scroll vertically to the times section
      timesSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start", // Aligns the times section to the top of the viewport
      });

      // Skip this block on first render
      if (containsDevOrMaster && !skipScrollAdjustment) {
        // Adjust vertical scroll after 500ms delay to ensure initial scroll finishes
        setTimeout(() => {
          const newScrollY = window.scrollY + 450;
          window.scrollTo({ top: newScrollY, left: window.scrollX, behavior: "smooth" });
        }, 500); // Keep 500ms delay to allow initial scroll to complete
      }
    } else {
      // Fallback for older browsers or if the timesSectionRef is null
      const yOffset = window.pageYOffset + window.scrollY - 20; // Adjust the offset as needed
      window.scrollTo({ top: yOffset, behavior: "smooth" });

      // Skip this block on first render
      if (containsDevOrMaster && !skipScrollAdjustment) {
        setTimeout(() => {
          const newScrollY = window.scrollY + 450;
          window.scrollTo({ top: newScrollY, left: window.scrollX, behavior: "smooth" });
        }, 500); // Keep 500ms delay for fallback scroll
      }
    }
  };

  // Albany, NY - United States   
  const parseDateLocal = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  // Combined useEffect to handle both initial and subsequent scrolls
  useEffect(() => {
    // Set the width for iframe Google map
    const updateWidth = () => {
      if (window.innerWidth <= 768) {
        setWidth("100%");
      } else {
        setWidth(300); // Set default width for larger screens
      }
    };

    // Initial width update and event listener
    updateWidth();
    window.addEventListener("resize", updateWidth);

    const date = new Date();
    const day = date.getDay();
    setAppointmentDetail({ date, start: "", end: "" });
    setFetchTimeLoading(true);

    const localMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const year = localMidnight.getFullYear();
    const month = String(localMidnight.getMonth() + 1).padStart(2, "0");
    const newDay = String(localMidnight.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${newDay}`;
    setSelectedDate(formattedDate);

    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-based index, so adding 1
    // const newDay = String(date.getDate()).padStart(2, "0"); // getDate() returns the day of the month
    // const formattedDate = `${year}-${month}-${newDay}`;
    // setSelectedDate(formattedDate);

    if (buttonClicked === 'appointment') {
      fetchTimes(day, formattedDate);
    }
    setFetchTimeLoading(false);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  // Re-fetch times when countryDetails loads (may arrive after initial mount)
  useEffect(() => {
    if (countryDetails?.time_zone && buttonClicked === "appointment" && selectedDate) {
      const date = new Date(value);
      const day = date.getDay();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const newDay = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${newDay}`;
      fetchTimes(day, formattedDate);
    }
  }, [countryDetails?.time_zone]);

  // Handle scrolling when times change or on first render
  useEffect(() => {
    if (!isWebView && times.length > 0) {
      // Call the scrollToTimesSection function
      scrollToTimesSection(isInitialRender.current);

      // Mark that the initial render is complete
      isInitialRender.current = false;
    }
  }, [times]);

  const onChangeDate = async (e) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const selectedDate = new Date(e);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      // Check if a toast is currently visible
      if (!isToastVisible) {
        setIsToastVisible(true);
        toast.error("Please select today's date or a future date");
        // Reset the flag after the toast is hidden
        setTimeout(() => {
          setIsToastVisible(false);
        }, 3000);
      }
      return;
    }
    
    setValue(e);
    console.log(e, "<---e");
    console.log(value, "<---value");
    
    const date = new Date(e);
    setAppointmentDetail({ date, start: "", end: "" });
    setTimes([]);
    setFilteredTime([]);
    const day = date.getDay();
    setFetchTimeLoading(true);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-based index, so adding 1
    const newDay = String(date.getDate()).padStart(2, "0"); // getDate() returns the day of the month
    const formattedDate = `${year}-${month}-${newDay}`;

    setSelectedDate(formattedDate);
    if (buttonClicked === 'appointment') {
      await fetchTimes(day, formattedDate);
    }
    setFetchTimeLoading(false);
  };

  const onTimeHandler = (time) => {
    setAppointmentDetail({
      date: appointmentDetail?.date,
      start: time?.start,
      end: time?.end,
    });
  };

  const fetchTimes = async (day, date) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_APPOINTMENT_PRO_API_URL}/${UrlServices.getTimes}`,
        {
          index: day,
          calendar_date: date,
          q_: encryptionKey,
          store_timezone: countryDetails?.time_zone || "UTC",
        }
      );

      // Client-side guard: filter past slots for today in store timezone
      const timezone = countryDetails?.time_zone || "UTC";
      const todayInZone = formatInTimeZone(new Date(), timezone, "yyyy-MM-dd");
      const isToday = todayInZone === date;
      const currentTimeInZone = isToday
        ? formatInTimeZone(new Date(), timezone, "HH:mm")
        : null;

      const slots = (data?.times || []).filter(
        (slot) => !isToday || slot.start >= currentTimeInZone
      );

      setTimes(slots);
      setFilteredTime(slots.filter((t, index) => index >= 0 && index <= 4));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div
      style={{
        '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
      }}
      className={`quote-colum ${
        buttonClicked === "appointment"
          ? "quote-booking-scroller quote-scroll-booking-details md:rd-quote-border md:rd-quote-p-4 md:rd-quote-rounded-md md:rd-quote-border-[var(--border-bg-color)]"
          : "rd-quote-border rd-quote-p-4 rd-quote-rounded-md rd-quote-border-[var(--border-bg-color)]"
      } rd-quote-mt-3 rd-quote-border-gray-300 md:rd-quote-shadow`}
    >
      <Toaster position="bottom-center" />
      <div className="quote-row-justify quote-direction-column">
        <div className="quote-colum">
          <div
            className={`${
              !isWebView && buttonClicked === "appointment"
                ? "rd-quote-bg-gray-100 rd-quote-py-1 rd-quote-px-4 rd-quote-rounded-md"
                : ""
            } rd-quote-flex rd-quote-justify-between rd-quote-items-center rd-quote-mb-2`}
          >
            <span className="quote-text2">{bookingDetail.name}</span>
            {!isWebView && (
              <span
                style={{
                  '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                }}
                className="rd-quote-cursor-pointer rd-quote-text-[var(--border-bg-color)] rd-quote-min-w-[105px] rd-quote-text-center"
                onClick={handleViewMap}
              >
                View on map
              </span>
            )}
          </div>

          {/* for mobile */}
          {!isWebView && buttonClicked === "appointment" && (
            <div className="rd-quote-flex rd-quote-justify-center">
              <span className="rd-quote-font-bold">Select a Date</span>
            </div>
          )}

          {/* for tablet and laptop screen */}
          {(isWebView || buttonClicked === "quote") && (
            <div className="quote-row rd-quote-mb-2">
              <span>
                {" "}
                <IconMapPin className="rd-quote-w-5 rd-quote-h-5  rd-quote-text-gray-500" />
              </span>
              <div className="quote-text1 rd-quote-ml-2 rd-quote-break-words rd-quote-max-w-[600px]">
                {bookingDetail.address !== ""
                  ? bookingDetail.address.concat(", ")
                  : ""}
                {bookingDetail.city.concat(" ")}
                {bookingDetail.state.concat(" ")}
                {bookingDetail.postcode !== ""
                  ? bookingDetail.country !== ""
                    ? bookingDetail.postcode.concat(", ")
                    : bookingDetail.postcode
                  : ""}
                {bookingDetail.country}
              </div>
            </div>
          )}

          {/* for tablet and laptop screen */}
          {(isWebView || buttonClicked === "quote") && (
            <div className="quote-row">
              <IconClock className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-gray-500" />
              <span
                className={`${
                  getStoreTime(bookingDetail.start_time, bookingDetail.end_time)
                    ? "rd-quote-text-green-600"
                    : "rd-quote-text-rose-600"
                } rd-quote-text-sm rd-quote-font-normal
                 rd-quote-font-['SF Pro Text'] rd-quote-leading-5 rd-quote-mx-2`}
              >
                {getStoreTime(bookingDetail.start_time, bookingDetail.end_time)
                  ? "Open"
                  : "Closed"}
              </span>
              <span className="quote-text1">-</span>
              <div className="quote-text1 rd-quote-ml-2">
                {/* Closed at {bookingDetail.end_time.substring(0, 5)}pm */}
                Closed at{" "}
                {bookingDetail?.end_time &&
                  (bookingDetail?.time_format === 0
                    ? formatTo12Hour(bookingDetail.end_time)
                    : bookingDetail.end_time.substring(0, 5))}
              </div>
            </div>
          )}
        </div>

        {/* for tablet and laptop screen */}
        {isWebView && (
          <div className="quote-margin-top">
            <iframe
              title="google map"
              src={`https://www.google.com/maps/embed/v1/place?key=${key}&q="+ ${encodeURIComponent(
                bookingDetail.address
              )}"`}
              width={width}
              height="140"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        )}
      </div>
      {buttonClicked === "appointment" && (
        <div
          className={`${
            !isWebView && buttonClicked === "appointment"
              ? ""
              : "quote-margin-top"
          } rd-quote-flex xs:rd-quote-flex-col lg:rd-quote-flex-row lg:rd-quote-items-unset xs:rd-quote-items-center v-xs-direction-col ${
            isWebView && (fetchTimeLoading || filteredTime?.length === 0)
              ? "rd-quote-mb-[3rem]"
              : "rd-quote-mb-[1.6rem]"
          } lg:rd-quote-mx-4 rd-quote-gap-x-12`}
        >
          <Calendar
            className={`rd-quote-w-[100%] rd-quote-border-none ${
              isWebView && (fetchTimeLoading || filteredTime?.length === 0)
                ? "rd-quote-mt-5"
                : ""
            }`}
            onChange={onChangeDate}
            value={value}
          />
          {fetchTimeLoading ? (
            <>
              <div className="rd-quote-flex rd-quote-justify-center rd-quote-items-center rd-quote-flex">
                <BeatLoader
                  loading={fetchTimeLoading}
                  size={10}
                  className="lg:rd-quote-mx-[86px]"
                />
              </div>
            </>
          ) : (
            <>
              {filteredTime?.length === 0 ? (
                <div className="rd-quote-flex rd-quote-justify-center rd-quote-items-center">
                  {buttonClicked === "appointment" && (
                    <div className="rd-quote-w-[215px] rd-quote-py-1.5 rd-quote-border rd-quote-border-gray-200 rd-quote-rounded-md rd-quote-text-center rd-quote-justify-center rd-quote-flex quote-text1">
                      No time available
                    </div>
                  )}
                </div>
              ) : // for laptop screens
              isWebView ? (
                <div
                  style={{
                    '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                  }}
                  className={`xs:rd-quote-mt-8 lg:rd-quote-mt-0 rd-quote-flex rd-quote-flex-col rd-quote-row rd-quote-items-center
              ${
                times[0].start
                  ? "rd-quote-rounded-md rd-quote-border rd-quote-border-[var(--border-bg-color)] lg:rd-quote-px-4 rd-quote-py-4 xs:rd-quote-w-[220px] lg:rd-quote-h-[350px] lg:rd-quote-w-[60%] lg:rd-quote-mt-2.5"
                  : ""
              }`}
                >
                  <div className="rd-quote-mb-2">
                    {format(parseDateLocal(selectedDate), "eee, LLL dd, yyyy")}
                    {/* {format(new Date(selectedDate), "eee, LLL dd, yyyy")} */}
                  </div>
                  {buttonClicked === "appointment" && (
                    <div className="rd-quote-flex rd-quote-flex-col rd-quote-items-center time-overflow scrollbar-colorr rd-quote-w-full rd-quote-gap-y-2">
                      {times?.map((time) => (
                        <div
                          key={time.start}
                          style={{
                            '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                          }}
                          className={`rd-quote-py-1.5 rd-quote-w-[170px] time-text-center rd-quote-border rd-quote-rounded-md rd-quote-border-gray-300 rd-quote-cursor-pointer ${
                            time.start === appointmentDetail?.start
                              ? "rd-quote-bg-[var(--border-bg-color)]"
                              : ""
                          }`}
                          onClick={() => onTimeHandler(time)}
                        >
                          <div
                            className={`quote-text3 rd-quote-w-[70px] ${
                              time.start === appointmentDetail?.start
                                ? "rd-quote-text-white"
                                : ""
                            }`}
                          >
                            {time?.start &&
                              (bookingDetail?.time_format === 0
                                ? formatTo12Hour(time.start)
                                : time.start)}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                // for mobile screens
                !isWebView && (
                  <div ref={timesSectionRef}>
                    <div className="rd-quote-flex rd-quote-flex-col rd-quote-gap-y-1 rd-quote-items-center rd-quote-mt-2">
                      <span className="rd-quote-font-bold">Select a time</span>
                      <span>
                        {format(new Date(selectedDate), "eeee, LLL dd, yyyy")}
                      </span>
                    </div>
                    <div className="quote-card-grid rd-quote-gap-x-3 rd-quote-mt-5 scrollbar-colorr">
                      {times?.map((time) => (
                        <span
                          style={{
                            '--border-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                          }}
                          className={`rd-quote-cursor-pointer rd-quote-border rd-quote-border-gray-200 rd-quote-rounded-md rd-quote-w-36 rd-quote-text-center rd-quote-py-1 rd-quote-text-sm ${
                            time.start === appointmentDetail?.start
                              ? "rd-quote-bg-[var(--border-bg-color)] rd-quote-text-white"
                              : ""
                          }`}
                          onClick={() => onTimeHandler(time)}
                        >
                          {time?.start &&
                            (bookingDetail?.time_format === 0
                              ? formatTo12Hour(time.start)
                              : time.start)}
                        </span>
                      ))}
                    </div>
                  </div>
                )
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BookingDetails;
